import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        // 登录
        {
            path: "/",
            name: "login",
            component: () =>
                import ("../views/login2"),
            meta: {
                title: "登录"
            }
        },
        // 首页提示
        {
            path: "/index",
            name: "index",
            component: () =>
                import ("../views/index/index"),
            meta: {
                title: "体检服务",
                requireAuth: true,
                id: 1
            }
        },
        // 首页
        {
            path: "/home",
            name: "index",
            component: () =>
                import ("../views/index/index"),
            meta: {
                title: "体检服务",
                requireAuth: true,
                id: 1
            }
        },
        // 预约体检界面包括本人体检和家属体检
        {
            path: "/subscribe",
            name: "subscribe",
            component: () =>
                import ("../views/subscribe/subscribe.vue"),
            meta: {
                title: "预约体检",
                requireAuth: true,
                isBack: false,
                keepAlive: true,
                id: 1,
                isUseCache: false
            },
        },


        // 个人中心界面
        {
            path: "/personal",
            name: "personal",
            component: () =>
                import ("../views/personal/personal.vue"),
            meta: {
                title: "个人中心",
                requireAuth: true,
                id: 2
            }
        },
        // 订单确认界面
        {
            path: "/confirm",
            name: "confirm",
            component: () =>
                import ("../views/confirm/confirm.vue"),
            meta: {
                title: "订单确认",
                requireAuth: true,
                id: 1
            }
        },


        // 体检报告界面
        {
            path: "/report",
            name: "report",
            component: () =>
                import ("../views/report/report.vue"),
            meta: {
                title: "体检报告",
                requireAuth: true,
                id: 1
            }
        },
        // 体检报告详情界面
        {
            path: "/reportImg",
            name: "reportImg",
            component: () =>
                import ("../views/reportImg/reportImg.vue"),
            meta: {
                title: "体检报告详情",
                requireAuth: true,
                id: 1
            }
        },

        // 投诉建议页面
        {
            path: "/suggestion",
            name: "suggestion",
            component: () =>
                import ("../views/suggestion/suggestion.vue"),
            meta: {
                title: "满意度调查",
                requireAuth: true,
                id: 1
            }
        },
        {
            path: "/suggestionOffline",
            name: "suggestionOffline",
            component: () =>
                import ("../views/suggestion/suggestionOffline.vue"),
            meta: {
                title: "线下满意度调查",
                requireAuth: true,
                id: 1
            }
        },
        // 我的订单界面
        {
            path: "/order",
            name: "order",
            component: () =>
                import ("../views/order/order.vue"),
            meta: {
                title: "体检订单",
                requireAuth: true,
                id: 2,
                isBack: false,
                keepAlive: true
            }
        },
        // 我的订单界面
        {
            path: "/orderTeeth",
            name: "orderTeeth",
            component: () =>
                import ("../views/order/orderTeeth.vue"),
            meta: {
                title: "齿科订单",
                requireAuth: true,
                id: 2,
                isBack: false,
                keepAlive: true
            }
        },
        // 我的订单详情界面
        {
            path: "/orderDetail",
            name: "orderDetail",
            component: () =>
                import ("../views/orderDetail/orderDetail.vue"),
            meta: {
                title: "体检订单详情",
                requireAuth: true,
                id: 2
            }
        },
        // 我的订单详情界面
        {
            path: "/orderDetailTeeth",
            name: "orderDetailTeeth",
            component: () =>
                import ("../views/orderDetail/orderDetailTeeth.vue"),
            meta: {
                title: "齿科订单详情",
                requireAuth: true,
                id: 2
            }
        },
        // 满意度调查
        {
            path: "/survey",
            name: "survey",
            component: () =>
                import ("../views/survey/survey.vue"),
            meta: {
                title: "线上满意度调查",
                requireAuth: true,
                id: 2
            }
        },
        // 满意度调查2
        {
            path: "/surveyOffline",
            name: "surveyOffline",
            component: () =>
                import ("../views/survey/surveyOffline.vue"),
            meta: {
                title: "线下满意度调查",
                requireAuth: true,
                id: 2
            }
        },
        //预约成功界面
        {
            path: "/success",
            name: "success",
            component: () =>
                import ("../views/statusPage/success/success.vue"),
            meta: {
                title: "预约成功",
                requireAuth: true,
                id: 1
            }
        },
        //预约中界面
        {
            path: "/successMiddle",
            name: "success",
            component: () =>
                import ("../views/statusPage/success/successMiddle.vue"),
            meta: {
                title: "预约成功",
                requireAuth: true,
                id: 1
            }
        },
        // 预约失败界面
        {
            path: "/error",
            name: "error",
            component: () =>
                import ("../views/statusPage/errorPage/error.vue"),
            meta: {
                title: "预约失败",
                requireAuth: true,
                id: 1
            }
        },
        // 预约等待中界面
        {
            path: "/middlePage",
            name: "middlePage",
            component: () =>
                import ("../views/statusPage/middlePage/middlePage.vue"),
            meta: {
                title: "预约中",
                requireAuth: true,
                id: 1
            }
        },
        // 选择体检人的信息
        {
            path: "/checkPerson",
            name: "checkPerson",
            component: () =>
                import ("../views/checkPerson/checkPerson.vue"),
            meta: {
                title: "选择体检人"
            }
        },
        {
            path: "/pdf",
            name: "Pdf",
            component: () =>
                import ("@/components/pdf/pdf"),
            meta: {
                title: "pdf"
            }
        },
        {
            path: "/middlePageTeeth",
            name: "middlePageTeeth",
            component: () =>
                import ("../views/statusPage/middlePageTeeth/middlePageTeeth.vue"),
            meta: {
                title: "预约中"
            }
        },
        {
            path: "/settings",
            name: "settings",
            component: () =>
                import ("../views/personal/settings.vue"),
            meta: {
                title: "设置"
            }
        },
        {
            path: "/saled",
            name: "saled",
            component: () =>
                import ("../views/saled/saled.vue"),
            meta: {
                title: "售后列表"
            }
        },

        {
            path: "/saledEdit",
            name: "saledEdit",
            component: () =>
                import ("../views/saled/saledEdit.vue"),
            meta: {
                title: "编辑售后"
            }
        },
        {
            path: "/saledDetail",
            name: "saledDetail",
            component: () =>
                import ("../views/saled/saledDetail.vue"),
            meta: {
                title: "售后详情"
            }
        },
        {
            path: "/confirmInformation",
            name: "confirmInformation",
            component: () =>
                import ("../components/confirmInformation.vue"),
            meta: {
                title: "确认信息"
            }
        },
        {
            path: "/explain",
            name: "explain",
            component: () =>
                import ("../views/explain/explain.vue"),
            meta: {
                title: "报告解读"
            }
        },
        {
            path: "/packageComparison",
            name: "packageComparison",
            component: () =>
                import ("../views/packageComparison/packageComparison.vue"),
            meta: {
                title: "套餐对比"
            }
        },




        // {
        //   path: "/healthInformation",
        //   name: "healthInformation",
        //   component: () =>
        //     import("../views/healthInformation/healthInformation.vue"),
        //   meta: {
        //     title: "健康咨询",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },


        // {
        //   path: "/reimburse",
        //   name: "reimburse",
        //   component: () => import("../views/reimburse"),
        //   meta: {
        //     title: "在线报销",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/billConfirm",
        //   name: "billConfirm",
        //   component: () => import("../views/billConfirm"),
        //   meta: {
        //     title: "在线报销-信息确认",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/reimburseSuccess",
        //   name: "reimburseSuccess",
        //   component: () => import("../views/reimburseSuccess"),
        //   meta: {
        //     title: "在线报销-申请提交成功",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/exportFile",
        //   name: "exportFile",
        //   component: () => import("../views/exportFile"),
        //   meta: {
        //     title: "在线报销-导出报销单",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/dispatchList",
        //   name: "dispatchList",
        //   component: () => import("../views/dispatchList"),
        //   meta: {
        //     title: "报销单列表",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/dispatchDetail",
        //   name: "dispatchDetail",
        //   component: () => import("../views/dispatchDetail"),
        //   meta: {
        //     title: "报销单详情",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },
        // {
        //   path: "/declarationInformation",
        //   name: "declarationInformation",
        //   component: () => import("../views/declarationInformation"),
        //   meta: {
        //     title: "填写申报信息",
        //     requireAuth: true,
        //     id: 1
        //   }
        // },





    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js